// src/LoadingSpinner.js

import React from 'react';
import './LoadingSpinner.css'; // Assuming you have a separate CSS file for styles

const LoadingSpinner = () => {
  return (
    <div className="spinner-container">
      <div className="neomorphic-spinner"></div>
    </div>
  );
};

export default LoadingSpinner;
